import { object, string } from 'yup';
import { IInsurance, IInsuranceSchema } from '../forms/base-data';

export interface IHealthInsurance {
  number?: string;
  insurance?: IInsurance;
}

export const HealthInsuranceSchema = object({
  number: string().notRequired().nullable(),
  insurance: IInsuranceSchema.notRequired().nullable(),
});

export interface IHealthInsuranceInput {
  number?: string;
  insuranceId?: string;
}

export const HealthInsuranceInputSchema = object({
  number: string().notRequired().nullable(),
  insuranceId: string().notRequired().nullable(),
});
